import { render, staticRenderFns } from "./Chart.vue?vue&type=template&id=2394678c&scoped=true&"
import script from "./Chart.vue?vue&type=script&lang=ts&"
export * from "./Chart.vue?vue&type=script&lang=ts&"
import style0 from "./Chart.vue?vue&type=style&index=0&id=2394678c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2394678c",
  null
  
)

export default component.exports